<template>
    <div class="step">
        <div class="step__container">

            <div class="step__title" ref="title">
                <p>You’ll be the master account holder for this person.</p>
            </div>

            <div class="step__subtitle" ref="subtitle">
                <p>That means you’re email will be the main point of contact and receive updates and new information.</p>
            </div>

            <div class="step__button" ref="button">
                <a href="#" @click.prevent="goNextStep" class="button">
                    <span>Next</span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>

    import { TimelineMax } from 'gsap';

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step1_AccHolder',
        methods: {
            goNextStep() {
                this.$emit('nextStep')
            }
        },
        mounted() {
            amplitude.getInstance().logEvent('signup_page_master_loaded');
            const {title, subtitle, button} = this.$refs;
            tl
            .from([title, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step1_AccHolder.vue?fbc7cda6